import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'
export default async function (data) {
	const node = data.node;
	const title = node.title;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground()
	const ex8 = await getThemePic(data?.customTheme, 'ex-8')
	const ex9 = await getThemePic(data?.customTheme, 'ex-9')
	const ex10 = await getThemePic(data?.customTheme, 'ex-10')
	const ex11 = await getThemePic(data?.customTheme, 'ex-11')
	const ex12 = await getThemePic(data?.customTheme, 'ex-12')
	const ex13 = await getThemePic(data?.customTheme, 'ex-13')
	const ex14 = await getThemePic(data?.customTheme, 'ex-14')

	return {
		"id": id,
		"elements": [
			{
				"type": "text",
				"id": "-GbBtOG4B-",
				"width": 885.29,
				"height": 87.34375,
				"left": 57.35,
				"top": 173.85,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333",
				"content": `<p style=\"text-align: center;\"><span style=\"font-size: 67.35px;\"><span style=\"font-family: 幼圆;\"><span style=\"color: #55B577;\">${title}</span></span></span></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "image",
				"id": "00CfNR9LMB",
				"src": ex8,
				"width": 475.54,
				"height": 205.52,
				"left": -11.48,
				"top": 357.03,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": false,
				"flipV": false
			},
			{
				"type": "image",
				"id": "TRbttCG74H",
				"src": ex9,
				"width": 542.55,
				"height": 242.52,
				"left": 463.96,
				"top": 333.46,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": false,
				"flipV": false
			},
			{
				"type": "image",
				"id": "QUhcZdtLKR",
				"src": ex10,
				"width": 58.51,
				"height": 134.51,
				"left": 637.38,
				"top": 480.84,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": false,
				"flipV": false
			},
			{
				"type": "image",
				"id": "_xEC37_Cpr",
				"src": ex11,
				"width": 91.01,
				"height": 131.01,
				"left": 702.9,
				"top": 323.89,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": false,
				"flipV": false
			},
			{
				"type": "image",
				"id": "kf-f5Oiwuq",
				"src": ex12,
				"width": 81.01,
				"height": 157.01,
				"left": 512.06,
				"top": 497.47,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": false,
				"flipV": false
			},
			{
				"type": "image",
				"id": "z6UI2mTHyV",
				"src": ex13,
				"width": 81.51,
				"height": 143.01,
				"left": 246.81,
				"top": 352.71,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": false,
				"flipV": false
			},
			{
				"type": "image",
				"id": "q4YudC0n8X",
				"src": ex14,
				"width": 150.01,
				"height": 139.51,
				"left": 424.99,
				"top": 14.61,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": false,
				"flipV": false
			}
		],
		background
	};

}